import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    variant: 'odds',
    fontSize: 'sm',
    fontWeight: 'extrabold',
    fontFamily: 'Staatliches',
  },
  buttonBaseSpanProps: {
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
    textTransform: 'capitalize',
    fontWeight: 'extrabold',
    fontFamily: 'Staatliches',
    fontSize: '2xs',
  },
  buttonBaseBox: {
    fontSize: 'sm',
    fontWeight: 'normal',
    fontFamily: 'Staatliches',
  },
  textBase: {
    textAlign: 'center',
    color: 'beta.600',
  },
};
